import React, {useState, useContext} from "react"
import { Modal} from 'react-bootstrap';
import sticker from "../../../images/stickers_phonesmartsupport.png"
import "./KidsNeedHelp.scss"

const KidsNeedHelp = () => {
	const [show, setShow] = useState(false);
	let currentAvatar;
	const handleShow = () => { setShow(true); }
	const handleClose = () => { setShow(false); }

		return (		
		
			<div className="kids-help">
				<button className="" onClick={handleShow}
					data-analytics='{"event":"Navigation", "eventCategory":"Navigation", "eventAction":"Footer Link Click", "eventLabel":"Need any help?"}'>
					Here's what to do
				</button>	
			
				<Modal show={show} onHide={handleClose} className="kid-help-popup">
					<Modal.Body>
						<img src={sticker} alt="stickers phonesmart support"></img>
						<h3>Need some help?</h3>
						<p>Something not working?</p>
						<p>Ask your parent/ guardian to reach out to us through the Report an issue link in the footer of the grown ups section.</p>
					</Modal.Body>
					<Modal.Footer>
						<button className="btn btn-inset-border" onClick={handleClose}>Ok</button>
					</Modal.Footer>
				</Modal>
			</div>
		)
	
}

export default KidsNeedHelp
